import React, { ReactElement } from 'react';
import { Divider, Stack } from '@mui/material';
import { MemoProcessIcon } from 'components/common/ProcessIcon';
import { SubheaderText } from 'components/general';
import { ProcessType } from 'shared/domain/process/types/model';
import {
  inspectionFormPageHeaderRowSx,
  inspectionFormPageTitleSx,
} from './layout';

export function FormPageHeader({
  title,
  process,
}: {
  title: string;
  process?: ProcessType;
}): ReactElement {
  return (
    <>
      <Stack direction="row" alignItems="center" sx={inspectionFormPageHeaderRowSx}>
        {process ? (
          <MemoProcessIcon code={process.code} color={process.color} />
        ) : null}
        <SubheaderText sx={inspectionFormPageTitleSx}>{title}</SubheaderText>
      </Stack>
      <Divider />
    </>
  );
}
